const getLuminance = (hex: string) => {
  hex = hex.replace('#', '');
  const rgb = parseInt(hex, 16);
  const r = (rgb >> 16) & 0xff;
  const g = (rgb >> 8) & 0xff;
  const b = (rgb >> 0) & 0xff;

  const luminance = [r, g, b].map((v) => {
    v /= 255;

    return v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4);
  });

  return luminance[0] * 0.2126 + luminance[1] * 0.7152 + luminance[2] * 0.0722;
};

function getContrastRatio(color1: string, color2: string) {
  const l1 = getLuminance(color1);
  const l2 = getLuminance(color2);

  return (Math.max(l1, l2) + 0.05) / (Math.min(l1, l2) + 0.05);
}

const adjustColorForReadability = (
  color: string,
  backgroundColor: string = '#FFFFFF',
  targetRatio: number = 4.5,
) => {
  if (color === '#fe3b1f') return color;

  let adjustedColor = color.replace('#', '');
  let contrast = getContrastRatio(adjustedColor, backgroundColor);

  while (contrast < targetRatio) {
    adjustedColor =
      adjustedColor
        .match(/.{2}/g)
        ?.map((hex) =>
          Math.max(0, parseInt(hex, 16) - 1)
            .toString(16)
            .padStart(2, '0'),
        )
        .join('') || adjustedColor;

    if (adjustedColor === '000000') break;

    contrast = getContrastRatio(adjustedColor, backgroundColor);
  }

  return '#' + adjustedColor;
};

export { adjustColorForReadability };
